import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Card,
    Divider,
    Icon, IconButton,
    List,
    ListItem,
    ListItemText, makeStyles, Tooltip
} from "@material-ui/core";
import {Droppable, Draggable} from "react-beautiful-dnd";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../JsonScreen/Utils/lib";

const styles = () => ({
    cardContentWrapper: {
        height: 120,
        overflowY: "auto"
    },
    cardContentRoot: {
        padding: 0,
        overflowY: "auto"
    },
    editIcon: {
        padding: 0
    },
    list: {
        paddingTop: 0
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        margin: '0 2px',
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
});
const useStyles = makeStyles(() => ({
    cardContentWrapper: {
        height: 120,
        overflowY: "auto"
    },
    cardContentRoot: {
        padding: 0,
        overflowY: "auto"
    },
    editIcon: {
        padding: 0
    },
    list: {
        paddingTop: 0
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        margin: '0 2px',
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
}))
const SortColumns = (props) => {
    const {changeDirection, sortColumns, sourceColumns} = props;
    const classes = useStyles();

    return (
        <Card className={classes.fieldset}>
            <legend style={{fontWeight: 'bold'}}>
                Sort Columns
            </legend>
            <Divider/>
            <Droppable droppableId={'sortColumns'}>
                {(provided) => (
                    <div className={classes.cardContentWrapper}
                         {...provided.droppableProps}
                         ref={provided.innerRef}
                    >
                        <List
                            className={classes.list}
                            dense={true}
                        >
                            <RenderColumns
                                changeDirection={changeDirection}
                                sortColumns={sortColumns}
                                sourceColumns={sourceColumns}
                            />
                        </List>
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </Card>
    )
}

const RenderColumns = ({sourceColumns = [], sortColumns, changeDirection}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    return (
        sortColumns.map((column, index) => {
            const multiLanguageLabel = multiLanguageValue(getLabelColumn(sourceColumns, column), userLanguage);
            return (
                <React.Fragment key={`sort_${column.field}_${index}`}>
                    <Draggable
                        draggableId={`${column.field}_sort`}
                        index={index}>
                        {(provided, snapshot) => (
                            <>
                                <ListItem
                                    classes={{dense: classes.listItemDense}}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    selected={snapshot.isDragging}
                                >
                                    <ListItemText primary={multiLanguageLabel}/>
                                    <IconButton
                                        onClick={(event) => changeDirection(event, index, column.direction)}
                                        classes={{root: classes.editIcon}}>
                                        {column.direction === 'ASC' ? (
                                            <Tooltip title={'ASC'}>
                                                <Icon fontSize={"small"}>
                                                    arrow_upward
                                                </Icon>
                                            </Tooltip>
                                        ) : (
                                            <Tooltip title={'DESC'}>
                                                <Icon fontSize={"small"}>
                                                    arrow_downward
                                                </Icon>
                                            </Tooltip>
                                        )}
                                    </IconButton>
                                </ListItem>
                                <Divider/>
                            </>
                        )}
                    </Draggable>
                </React.Fragment>
            )
        })
    )
}

export default withStyles(styles)(SortColumns)


const getLabelColumn = (source, column) => {
    let label = '';
    source.forEach(s => {
        if (column.field === s.name) {
            label = s.label
        }
    });
    return label;
};